import { Textarea } from '@skytech/ui'
import { getLocaleTimezoneIsoDate, getWhiteLabelForDealerStyle } from '@skytech/utils'
import { useDispatch, useSelector } from 'react-redux'

import { useAppContext } from '@/App.context'
import Button from '@/components/form/Button'
import Input from '@/components/form/Input'
import { Translation } from '@/components/i18n/Translation'
import {
  getDeviceOrder,
  getIsPostPending,
  saveDeviceOrder,
  updateOrderProp,
} from '@/ducks/deviceOrderReducer'
import { WEEK } from '@/util/formatters/dates'
import { DEVICE_ORDER_STATUS } from '@/util/orders'

const DeviceOrderInputs = () => {
  const { whiteLabel } = useAppContext()
  const dispatch = useDispatch()

  const { dealer_comment, customer_comment, estimated_delivery, delivery_date, imei, id, status } =
    useSelector(getDeviceOrder)
  const isPostPending = useSelector(getIsPostPending)
  // @ts-ignore
  const submit = e => {
    e.preventDefault()
  }
  return (
    <section>
      <h3>
        <Translation id="Notes" />
      </h3>

      <form onSubmit={submit}>
        {status === DEVICE_ORDER_STATUS.AT_VENDOR && (
          <div>
            <Input
              type="date"
              value={getLocaleTimezoneIsoDate(estimated_delivery)}
              onChange={e =>
                dispatch(updateOrderProp({ prop: 'estimated_delivery', value: e.target.value }))
              }
              disabled={isPostPending}
              label={<Translation id="Estimated delivery" />}
              min={getLocaleTimezoneIsoDate(new Date())}
            />
          </div>
        )}

        {[DEVICE_ORDER_STATUS.SENT_TO_ECOM, DEVICE_ORDER_STATUS.PROCESSED].includes(status) && (
          <div>
            <Input
              type="date"
              value={getLocaleTimezoneIsoDate(delivery_date)}
              onChange={e =>
                dispatch(updateOrderProp({ prop: 'delivery_date', value: e.target.value }))
              }
              disabled={isPostPending}
              label={<Translation id="Delivery date" />}
              min={getLocaleTimezoneIsoDate(new Date(Date.now() - WEEK))}
            />
          </div>
        )}

        <div>
          <Input
            value={imei || ''}
            label={<Translation id="Imei" />}
            onChange={e => dispatch(updateOrderProp({ prop: 'imei', value: e.target.value }))}
            disabled={isPostPending}
          />
        </div>

        <div>
          <Textarea
            value={dealer_comment || ''}
            onChange={e =>
              dispatch(updateOrderProp({ prop: 'dealer_comment', value: e.target.value }))
            }
            // @ts-ignore
            disabled={isPostPending}
            label={<Translation id="Your comment" />}
            whiteLabel={getWhiteLabelForDealerStyle(whiteLabel)}
          />
        </div>

        <div>
          <Textarea
            value={customer_comment || ''}
            onChange={e =>
              dispatch(updateOrderProp({ prop: 'customer_comment', value: e.target.value }))
            }
            // @ts-ignore
            disabled={isPostPending}
            label={<Translation id="Customer comment" />}
            whiteLabel={getWhiteLabelForDealerStyle(whiteLabel)}
          />
        </div>

        <div>
          {/* @ts-ignore */}
          <Button onClick={() => dispatch(saveDeviceOrder(id))} disabled={isPostPending}>
            <Translation id="Update order" />
          </Button>
        </div>
      </form>
    </section>
  )
}

export default DeviceOrderInputs
